module.exports = __webpack_public_path__ + "img/type_list_more.2c62ea57.png";